import React, { useEffect } from "react";
 
import Navbar from "../components/homepage/Navbar";
import Hero from "../components/vendorOnboarding/VendorOnboarding";
import { Header, Footer } from "../shared";

const VendorOnboardingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>

      <Hero />

      <Footer />
    </div>
  );
};

export default VendorOnboardingPage;
